export enum  UserStatusEnum {
  AWAITINGAPPROVAL,
  ACTIVE,
  INACTIVE
}


